import { Box } from "@mui/material";
import { useTheme } from "@emotion/react";

export default function ChartPieTooltip({ active, payload, tooltipPos }) {
	const theme = useTheme();
	if (!active || !payload || payload.length === 0) return null;
	const { name, value } = payload[0];

	const tooltipStyles = {
		position: "fixed",
		top: tooltipPos.y + 10,
		left: tooltipPos.x + 10,
		backgroundColor: theme.palette.background.paper,
		border: `1px solid ${theme.palette.border.main}`,
		padding: "5px",
		borderRadius: "4px",
		pointerEvents: "none",
		zIndex: 1000,
	};

	return (
		<Box sx={tooltipStyles}>
			{name}:{" "}
			<strong>{`${Number(value).toFixed(2).toLocaleString()} ${localStorage.getItem(
				"userCurrency"
			)}`}</strong>
		</Box>
	);
}
